<div class="custom-mat-dialog-form">
  <div>
    <h3>Add Command</h3>
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="mt-2">
        <label>Command Key</label>
        <div class="input">
          <div class="input">
            <mat-select formControlName="commandKey" class="form-control" required>
              @for (cmd of commandKeys; track cmd) {
                <mat-option [value]="cmd.Key">
                  {{ cmd.Description }}
                </mat-option>
              }
            </mat-select>
          </div>
          @if (submitted && f['commandKey'].invalid) {
            <div class="invalid-feedback">
              <div class="error-div">Command must be selected</div>
            </div>
          }
        </div>
      </div>
      <div class="mt-2 right">
        <button type="button"
          class="btn btn-danger"
          (click)="onNoClick()">
          Close
        </button>
        <button type="submit"
          class="btn btn-primary"
          [disabled]="form.invalid">
          Add
        </button>
      </div>
    </form>
  </div>
</div>